import API from "@/services/api";

export default {
  getSchoolCounts() {
    return API().get("mio/school-counts");
  },
  getTeacherCounts() {
    return API().get("mio/teacher-counts");
  },
  getStudentCounts() {
    return API().get("mio/student-counts");
  },
  getCoordinatorCounts() {
    return API().get("mio/coordinator-counts");
  },
  getVisitCounts(type) {
    return API().get(`mio/visit-counts/${type}`);
  },
  getVisitCountsCountry(type) {
    return API().get(`mio/visit-counts-country/${type}`);
  },
  getGroupCounts1() {
    return API().get("mio/group-counts-1");
  },
  getGroupCounts2() {
    return API().get("mio/group-counts-2");
  },
  getTrainerGroups() {
    return API().get("mio/trainer-groups");
  },
  getTrainerVisits() {
    return API().get("mio/trainer-visits");
  },
  getSchoolLocations() {
    return API().get("mio/school-locations");
  },
  getGroupsYear() {
    return API().get("mio/groups-year");
  },
  getGroupsMonth() {
    return API().get("mio/groups-month");
  },
  getVisitsYear() {
    return API().get("mio/visits-year");
  },
  getVisitsMonth() {
    return API().get("mio/visits-month");
  },
  getModulesYear() {
    return API().get("mio/modules-year");
  },
  getModulesMonth() {
    return API().get("mio/modules-month");
  },
  getWorkshopsYear() {
    return API().get("mio/workshops-year");
  },
  getWorkshopsMonth() {
    return API().get("mio/workshops-month");
  },
  getStudentCountsYear() {
    return API().get("mio/student-counts-year");
  },
  getCertificates() {
    return API().get("mio/certificates");
  },
  getParentCertificates() {
    return API().get("mio/parent-certificates");
  },
  getParentCertificatesDistrict() {
    return API().get("mio/parent-certificates-district");
  },
  getClassroomAttainment(fromDate=false) {
    return API().get(`mio/classroom-attainment${fromDate ? `/${fromDate}` : ''}`);
  },
  getVisitsYearTeacher() {
    return API().get("mio/visits-year-teacher");
  },
  getVisitsYearSchool() {
    return API().get("mio/visits-year-school");
  },
  getTrainerCoordinatorPerformance() {
    return API().get("mio/trainer-coordinator-performance");
  },
  getRCPerformanceData(country, period) {
    return API().get(`mio/rc-performance-data/${country}/${period}`);
  },
  getRCBonusData(country, period) {
    return API().get(`mio/rc-bonus-data/${country}/${period}`);
  },
  getRemuneration() {
    return API().get("mio/remuneration");
  },
  getClassroomAttainmentSmall(fromDate=false, toDate=false) {
    return API().get(`mio/classroom-attainment-small${fromDate || toDate ? `/${fromDate || 0}` : ''}${toDate ? `/${toDate}` : ''}`);
  },
  getCovidObs() {
    return API().get("mio/covid-obs");
  },
  getCovidObsSmall() {
    return API().get("mio/covid-obs-small");
  },
  getDataConsentMonth() {
    return API().get("mio/data-consent-month");
  },
  getDataConsentYear() {
    return API().get("mio/data-consent-year");
  },
  getDataConsentYearDistrict() {
    return API().get("mio/data-consent-year-district");
  },
  getDataConsentersCountry(country) {
    return API().get(`mio/data-consenters-country/${country}`);
  },
  getDataConsentersPeriod(endDate) {
    return API().get(`mio/data-consenters-period/${endDate}`);
  },
  getStudentCountsMonth() {
    return API().get("mio/student-counts-month");
  },
  getTeacherCountsMonth() {
    return API().get("mio/teacher-counts-month");
  },
  getSchoolCountsMonth() {
    return API().get("mio/school-counts-month");
  },
  getStudentsCountryYear() {
    return API().get("/mio/students-country-year");
  },
  getSchoolsCountryYear() {
    return API().get("/mio/schools-country-year");
  },
  getTeachersCountryYear() {
    return API().get("/mio/teachers-country-year");
  },
  getCumStudentsCountryYear() {
    return API().get("/mio/cum-students-country-year");
  },
  getCumSchoolsCountryYear() {
    return API().get("/mio/cum-schools-country-year");
  },
  getCumTeachersCountryYear() {
    return API().get("/mio/cum-teachers-country-year");
  },
  getCumTeachersPhaseCountryYear() {
    return API().get("/mio/cum-teachers-phase-country-year");
  },
  getRCActiveTeamTrainers(id, period=false) {
    return API().get(`/mio/rc-active-team-trainers/${id}${period ? `/${period}` : ''}`);
  },
  getRCActiveTeamTrainerGroups(id) {
    return API().get(`/mio/rc-active-team-trainer-groups/${id}`);
  },
  getRCActiveTrainerRecentObservations(id) {
    return API().get(`/mio/rc-active-trainer-recent-observations/${id}`);
  },
  getRCActiveTrainerTeacherModules(id) {
    return API().get(`/mio/rc-active-trainer-teacher-modules/${id}`);
  },
  getRCMeta(id) {
    return API().get(`coordinators/${id}`);
  },
  getCountryRecentObservations(country) {
    return API().get(`mio/country-recent-observations/${country}`);
  },
  getCountryPeriodObservations(country, startDate, endDate) {
    return API().get(`mio/country-period-observations/${country}/${startDate}/${endDate}`);
  },
  getCountryStudentAttendance(country, fromYear) {
    return API().get(`mio/country-student-attendance/${country}/${fromYear}`);
  },
  getCountryModulesTaught(country) {
    return API().get(`mio/country-modules-taught/${country}`);
  },
  getTeachersUnderMaintenance() {
    return API().get(`mio/teachers-under-maintenance`);
  },
  getProgrammePhaseTeachers() {
    return API().get(`mio/programme-phase-teachers`);
  },
  getActiveProgrammePhaseTeachers(fromDate=false, groupByPeriod=false) {
    return API().get(`mio/active-programme-phase-teachers${fromDate || groupByPeriod ? `/${fromDate || 0}` : ''}${groupByPeriod ? `/${groupByPeriod}` : ''}`);
  },
  getWorkshopCounts() {
    return API().get("mio/workshop-counts");
  },
  getTeachersLastVisitPerGroup() {
    return API().get("mio/teachers-last-visit-per-group");
  },
  getGroupsByStartYear() {
    return API().get("mio/groups-start-year");
  },
  getModulesTaughtByYear() {
    return API().get("mio/modules-taught-year");
  },
  getAnnualCumulativeInteractionsData() {
    return API().get("mio/annual-cumulative-interactions-data");
  }
};
